import { Theme } from "common";

// Styles to keep the Table Header Label text white
export const whiteTableHeaderLabel = {
  "& .MuiTableSortLabel-root": {
    color: "white !important",
  },
  "& .MuiTableSortLabel-root:hover": {
    color: "white",
  },
  "&.Mui-active": {
    color: "white",
  },
  "& .MuiTableSortLabel-icon": {
    color: "white !important",
    alignSelf: "center",
  },
};

export const switchStyles = {
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 0.25,
    color: Theme.palette.grey[500],
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: Theme.palette.common.white,
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: Theme.palette.primary.main,
        borderColor: Theme.palette.primary.main,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 12,
    height: 12,
    borderRadius: 6,
    boxShadow: "none",
    transition: Theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    border: `1px solid ${Theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: Theme.palette.common.white,
    boxSizing: "border-box",
  },
};

// Allows cell text to wrap to multiple lines
export const multiLineCell = {
  textOverflow: "clip",
  whiteSpace: "break-spaces",
  lineHeight: 1.5,
  fontSize: "15px",
  alignSelf: "center",
  wordBreak: "break-word",
};

export const headerStyles = {
  textOverflow: "clip",
  whiteSpace: "break-spaces",
  lineHeight: 1,
  variant: "body2",
  fontWeight: 600,
  marginTop: "10px",
};

export const tableStyles = {
  boxShadow: 3,
  width: "100%",
  overflowX: "auto",
  "& .MuiDataGrid-virtualScroller": {
    overflow: "visible",
  },
  "& .MuiDataGrid-columnHeaderTitleContainer": {
    alignItems: "flex-start",
    marginTop: "12px",
    "& .MuiDataGrid-iconButtonContainer": {
      marginTop: "8px",
    },
  },
  "& .MuiDataGrid-columnHeader": {
    "&:focus": {
      outline: "none",
    },
    "&:focus-within": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    height: "100%",
  },
  "& .MuiDataGrid-scrollbar--horizontal ": {
    display: "initial",
  },
  "& .MuiDataGrid-filler": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader--last .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-columnSeparator": {
    justifyContent: "flex-start",
    marginTop: "40px",
    visibility: "visible",
  },
  "& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiTablePagination-root": {
    "& .MuiTablePagination-selectLabel": {
      fontSize: "14px",
    },
    "& .MuiTablePagination-displayedRows": {
      fontSize: "14px",
    },
    fontSize: "14px",
  },
  "&& .MuiIconButton-root": {
    width: "1em",
    height: "1em",
  },
  "& .Mui-odd": {
    backgroundColor: Theme.palette.primary.light,
    "&:hover": {
      backgroundColor: Theme.palette.primary.light,
    },
  },
  "& .Mui-even": {
    "&:hover": {
      backgroundColor: Theme.palette.primary.contrastText,
    },
  },
  "& .MuiDataGrid-iconButtonContainer": { paddingBottom: "5px" },
  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
    minHeight: "52px !important",
    padding: "5px 10px",
  },
  "& .MuiDataGrid-viewport, .MuiDataGrid-row, .MuiDataGrid-renderingZone": {
    maxHeight: "max-content !important",
  },
  "& .MuiDataGrid-columnHeader:focus": {
    outline: "none",
  },
  "& .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  "& .MuiDataGrid-row:last-of-type": {
    paddingBottom: "15px",
  },
  "& .interested-column": {
    backgroundColor: "#2F7D32",
  },
  "& .unsubscribed-column": {
    backgroundColor: "#ED6C03",
  },
};
